export default "__VITE_ASSET__CqfZv1Fe__"